import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {SmContextMenuModule} from '../sm-context-menu/sm-context-menu.module';
import {SmInputModule} from '../../form-controls/sm-input/sm-input.module';
import {SmSearchControlComponent} from './sm-search-control.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SmContextMenuModule,
    SmInputModule,
  ],
  declarations: [SmSearchControlComponent],
  exports: [SmSearchControlComponent],
})
export class SmSearchControlModule {}
